<template>
  
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
      <div class="container">
        <router-link class="navbar-brand"  to="/">Home</router-link> |

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample07" aria-controls="navbarsExample07" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>


      <div class="collapse navbar-collapse" id="navbarsExample07">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">

          <!-- <li class="nav-item"><router-link to="/about">About</router-link> | </li> -->
          <li class="nav-item"><router-link :to="{ name: 'random' }">Characters</router-link> |</li>
          <li class="nav-item"><router-link :to="{ name: 'locations' }">Locations</router-link>|</li>
          <li class="nav-item"><router-link :to="{ name: 'episodes' }">Episodes</router-link></li>
        </ul>

        
      </div>

      </div>
  </nav>

  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  /* color: #2c3e50; */
  color: #f8f8f8;
}

nav a.router-link-exact-active {
  // color: #42b983;
  color: cadetblue;
}

.routerlink, .routerlink a {
 text-decoration: none;
 color: #666;
}

.card-header, .card-footer {
  font-size: $cardheaderfootersize;
  font-weight: $cardheaderfooterweight;
}

.card-body a:hover {
  color: $cardbodyhovercolor;
  font-size: $cardbodyhoversize;
}

</style>
